<template>
  <div v-loading="loading">
    <div class="mb20 container">
      <div class="messageWrap">
        <!-- 交易代码 -->
        <p class="messageTitle">{{ $t("payment.transactionNo") }}</p>
        <div class="pt10">
          <p class="fs14" v-if="orderDetail.orderType == 'generic' || orderDetail.orderType == 'quotation_part'">{{ orderDetail?.companyApplyment?.applymentNo }}</p>
          <p class="fs14" v-if="orderDetail.orderType == 'adjustment'">{{ orderDetail?.adjustment?.adjustmentNo }}</p>
        </div>
      </div>

      <div class="pt30 messageWrap" v-if="orderDetail.orderType == 'generic' || orderDetail.orderType == 'quotation_part'">
        <!-- 拟设公司所在地 -->
        <p class="messageTitle">{{ $t("creation.locationTitle") }}</p>
        <div class="pt10 fs14">
          {{ getGlobalLabel("supportServiceCountryList", orderDetail?.companyApplyment?.country) }}
        </div>
      </div>

      <div class="pt30 messageWrap" v-if="orderDetail.orderType == 'generic' || orderDetail.orderType == 'quotation_part'">
        <!-- 确认套餐 -->
        <p class="messageTitle">{{ $t("payment.combo") }}</p>
        <div class="pt20">
          <template v-if="orderDetail.orderType == 'generic'">
            <!-- 套餐 -->
            <template v-if="orderDetail.goodsListType == 1">
              <Package :goodsList="orderDetail.goodsList" />
            </template>
            <!-- 自定义套餐 -->
            <template v-if="orderDetail.goodsListType == 2">
              <diy-package :businessType="orderDetail.businessType" :goodsList="orderDetail.goodsList" />
            </template>
          </template>
          <template v-if="orderDetail.orderType == 'quotation_part'">
            <!-- Quotation定制化服务-小计 -->
            <quotation-subtotal :businessType="orderDetail.businessType" :quotationPart="orderDetail.quotationPart" :billingCurrency="orderDetail.billingCurrency" />
          </template>
        </div>
      </div>

      <div class="pt30 messageWrap" v-if="orderDetail?.orderType == 'adjustment'">
        <!-- 确认补款 -->
        <p class="messageTitle">{{ $t("payment.amends") }}</p>
        <div class="pt20">
          <!-- Quotation(V)小额补款 - 单项 -->
          <quotation-v-single :adjustment="orderDetail.adjustment" :billingCurrency="orderDetail.billingCurrency" />
        </div>
      </div>
    </div>

    <div class="buyWrap">
      <div class="left">
        <p class="priceTitle">
          <span class="fs18 blue fwb mr4 el-icon-document"></span>
          {{ $t("payment.feeDetails") }}
        </p>
        <div class="priceItem">
          <p class="label">
            <template v-if="orderDetail.orderType == 'generic'">{{ $t("payment.package") }}</template>
            <template v-if="orderDetail.orderType == 'quotation_part'">{{ $t("payment.customized") }}</template>
            <template v-if="orderDetail.orderType == 'adjustment'">{{ $t("payment.supplemental") }}</template>
            <info-popover placement="right" :content="$t('payment.taxExcluded')" icon="el-icon-info" iconClass="ml2 fs13 blackD8" />
          </p>
          <p class="money">
            {{ priceCurrencyFormat(orderDetail.subtotalAmount, orderDetail.billingCurrency) }}
          </p>
        </div>
        <div class="priceItem">
          <p class="label">{{ $t("payment.taxAmount") }}</p>
          <p class="money">
            {{ priceCurrencyFormat(orderDetail.taxAmount, orderDetail.billingCurrency) }}
          </p>
        </div>
        <el-divider class="mt16 mb16"></el-divider>
        <div class="totalItem">
          <p class="label">{{ $t("payment.totalAmountDue") }}</p>
          <p class="orange money">
            {{ priceCurrencyFormat(orderDetail.totalAmount, orderDetail.billingCurrency) }}
          </p>
        </div>
      </div>
      <div class="right">
        <div class="msTitle">
          <div class="transferTitle" :class="{ active: payType == 1 }" @click="payChange(1)">
            <span class="el-icon-mobile-phone"></span>
            {{ $t("payment.alipayTransfer") }}
          </div>
          <div class="transferTitle" :class="{ active: payType == 2 }" @click="payChange(2)">
            <span class="el-icon-bank-card"></span>
            {{ $t("payment.bank") }}
          </div>
        </div>
        <div class="payWrap">
          <!-- 支付宝转账 -->
          <div class="alipayWrap" v-show="payType == 1">
            <div class="imgWrap" v-if="alipayInfo.url">
              <p class="title">
                {{ $t("payment.scanHint") }}
              </p>
              <div class="proceedsWrap">
                <img :src="alipayInfo.url" alt="" />
              </div>
            </div>
            <div class="accountsMessage">
              <p class="pb14">
                <span class="fs14">{{ $t("payment.amountInRMB") }}</span>
                <span class="fwb fs18 orange">{{ priceSymbolFormat(orderDetail.totalAmountCny, "¥") }}</span>
              </p>
              <div class="informWrap">
                <p class="fs12 lh22 orange fxVer">
                  <span class="mr4 fs15 orange el-icon-warning-outline"></span>
                  {{ $t("payment.paymentInstructions") }}
                </p>
                <p class="fs12 lh20 orange pb10">
                  {{ $t("payment.alipayGeneral") }}
                </p>
              </div>
              <div class="ruleWrap">
                <p class="fs12 lh22 black88 pb2">
                  {{ $t("payment.rule") }}
                </p>
                <p class="fs12 lh20 black88">
                  {{ $t("payment.sketch") }}
                </p>
              </div>
            </div>
          </div>
          <!-- 银行转账 -->
          <div class="accounts" v-show="payType == 2">
            <div class="warnTipe">
              <p class="orange">
                <span class="mr4 fs15 orange el-icon-warning-outline"></span>
                {{ $t("payment.transferNotice") }}
              </p>
              <p class="orange">
                {{ $t("payment.indication") }}
              </p>
              <p class="orange">
                {{ $t("payment.transferReminder") }}
              </p>
            </div>
            <template v-if="orderDetail?.bankAccountList?.length > 0">
              <div v-for="(item, index) in orderDetail.bankAccountList" :key="`bank-${item.id}`">
                <el-divider v-if="index > 0">
                  <p class="fs12 gray">
                    {{ $t("payment.or") }}
                  </p>
                </el-divider>
                <div class="bankWrap">
                  <template v-if="item?.qrcodeInfoList?.length > 0">
                    <div v-for="(con, idx) in item.qrcodeInfoList" :key="`qrcode-${idx}`">
                      <div class="accountImg" v-if="con.url">
                        <p class="enbr">{{ con.remark }}</p>
                        <img :src="con.url" alt="" />
                      </div>
                    </div>
                  </template>
                  <div class="accountMessage">
                    <div class="accountWrap">
                      <p class="accountTitle">
                        <span class="mr4 fs16 el-icon-bank-card"></span>
                        {{ $t("payment.gathering") }}
                      </p>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.bankName") }}
                        </p>
                        <p class="info">
                          {{ item.bankName || "" }}
                        </p>
                      </div>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.bankAddress") }}
                        </p>
                        <p class="info">
                          {{ item.bankAddress || "" }}
                        </p>
                      </div>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.swiftCode") }}
                        </p>
                        <p class="info">
                          {{ item.swiftCode || "" }}
                        </p>
                      </div>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.accountName") }}
                        </p>
                        <p class="info">
                          {{ item.accountName || "" }}
                        </p>
                      </div>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.companyAddress") }}
                        </p>
                        <p class="info">
                          {{ item.addressOfBeneficiary || "" }}
                        </p>
                      </div>
                      <div class="accountItem">
                        <p class="label">
                          {{ $t("payment.accountNumber") }}
                        </p>
                        <p class="info">
                          {{ item.accountNumber || "" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="mt20 reminderWrap">
      <!-- 提示说明： -->
      <p class="explainTitle">{{ $t("payment.explain") }}</p>
      <div class="explain">
        <p>{{ $t("payment.explainText01") }}</p>
        <p>{{ $t("payment.explainText02") }}</p>
        <p>{{ $t("payment.explainText03") }}</p>
        <p>{{ $t("payment.explainText04") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postRequest } from "@/api/common";
import Package from "@/components/ServiceGather/Package";
import DiyPackage from "@/components/ServiceGather/DiyPackage";
import QuotationSubtotal from "@/components/ServiceGather/QuotationSubtotal";
import QuotationVSingle from "@/components/ServiceGather/QuotationVSingle";
import formatMixin from "@/mixins/formatMixin";
import { mapGetters } from "vuex";
export default {
  name: "EnrollPayment",
  mixins: [formatMixin],
  components: {
    Package,
    DiyPackage,
    QuotationSubtotal,
    QuotationVSingle,
  },
  data() {
    return {
      orderDetail: {}, // 订单详情
      orderId: null, // 订单ID
      alipayInfo: {}, // 支付宝信息
      payType: 1, // 1支付宝转账(常用), 2银行转账
      loading: true,
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
  },
  methods: {
    // 页面初始化数据整理
    async pageInit() {
      try {
        this.loading = true;
        // 获取继续支付信息
        await this.getContinuePay();
        // 获取支付宝信息
        await this.getAlipayInfo();
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    // 获取支付宝信息
    getAlipayInfo() {
      return new Promise((resolve, reject) => {
        getAction("/stCustomPage/detail")
          .then(res => {
            const resData = res.data || {};
            const { alipayQrcodeUrl } = resData;
            this.alipayInfo = alipayQrcodeUrl;
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取继续支付信息
    getContinuePay() {
      return new Promise((resolve, reject) => {
        postRequest("/order/continuePay", {
          orderId: this.orderId,
        })
          .then(res => {
            const resData = res.data || {};
            this.orderDetail = resData;
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 切换支付宝或银行转账
    payChange(type) {
      this.payType = type;
    },
  },
  created() {
    const query = this.$route.query;
    if (query.orderId) {
      this.orderId = query.orderId;
      this.pageInit();
    } else {
      // 给出提示：缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace("/");
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  border-radius: 4px;
  font-size: 16px;
  line-height: 1em;
  font-weight: 600;
}

.alipayWrap {
  display: flex;

  .imgWrap {
    width: 200px;
    margin-right: 20px;

    .title {
      font-size: 12px;
      width: 100%;
      color: #bbc6d8;
      text-align: center;
      margin-bottom: 6px;
    }

    .proceedsWrap {
      width: 200px;
      // height: 200px;

      img {
        width: 100%;
        // height: 100%;
      }
    }
  }

  .accountsMessage {
    .informWrap {
      padding: 6px 10px 0px;
      background-color: #fdf6ec;
      border: 1px solid #faecd8;
      border-radius: 4px;
      margin-bottom: 16px;
    }

    .ruleWrap {
      padding: 6px 10px 10px;
      background-color: #f2f6fc;
      border-radius: 4px;
    }
  }
}

.buyWrap {
  display: flex;
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;

  .left,
  .right {
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;
  }

  .left {
    width: 300px;

    .priceTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 12px;
      display: flex;
      align-items: center;
    }

    .priceItem {
      display: flex;
      justify-content: space-between;
      line-height: 18px;
      padding: 8px 0;

      .label {
        text-align: left;
        color: #667288;
        font-size: 12px;
      }

      .money {
        text-align: right;
        color: #000;
        font-weight: bold;
        font-size: 14px;
      }
    }

    .totalItem {
      text-align: left;

      .label {
        font-size: 12px;
        color: #667288;
      }

      .money {
        color: #000;
        font-weight: bold;
        font-size: 20px;
      }
    }
  }

  .right {
    flex: 1;

    .msTitle {
      width: 600px;
      height: 46px;
      margin: 0 auto;
      background-color: #f2f6fc;
      border-radius: 4px;
      margin-bottom: 26px;
      display: flex;
      align-items: center;
      justify-content: center;

      .transferTitle {
        width: 296px;
        height: 38px;
        font-size: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          color: inherit;
          font-size: 16px;
          margin-right: 4px;
        }
      }

      .transferTitle.active {
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        font-weight: bold;
      }
    }

    .warnTipe {
      padding: 6px 10px;
      background-color: #fdf6ec;
      border: 1px solid #faecd8;
      border-radius: 4px;
      margin-bottom: 20px;

      p {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 22px;
      }
    }

    .bankWrap {
      display: flex;
      flex-wrap: wrap; /* 允许换行 */
      gap: 20px;

      .accountImg {
        width: 200px;

        p {
          font-size: 12px;
          text-align: center;
          padding-bottom: 6px;
        }

        img {
          width: 200px;
          // height: 200px;
        }
      }

      .accountMessage {
        min-width: 500px;
        flex: 1;

        .accountWrap {
          background-color: #f2f6fc;
          padding: 6px 10px;
          border-radius: 4px;
          height: 100%;

          .accountTitle {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            padding-bottom: 4px;
          }

          .accountItem {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #e4e7ed;

            p {
              font-size: 12px;
              line-height: 18px;
              padding: 6px 0;
            }

            .label {
              max-width: 166px;
              color: #667288;
            }

            .info {
              flex: 1;
              text-align: right;
            }
          }

          .accountItem:last-child {
            border: none;
          }
        }
      }
    }
  }
}

.reminderWrap {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;

  .explainTitle {
    color: #667288;
    line-height: 16px;
    padding-bottom: 6px;
    font-size: 12px;
  }

  .explain {
    p {
      color: #667288;
      font-size: 12px;
      line-height: 16px;
      padding-top: 10px;
    }
  }
}
</style>
